customElements.define("marquee-support", class extends HTMLElement {
  constructor() {
    super(), this.container = this.querySelector(".marquee"), this.content = this.container?.querySelector(".marquee__content"), 
    this.resizeObserver = null;
  }
  connectedCallback() {
    this.container && this.content && (this.cloneUntilFull(), this.observeResize());
  }
  cloneUntilFull() {
    const e = this.content, t = this.container.offsetWidth, s = e.scrollWidth;
    this.container.querySelectorAll('.marquee__content[aria-hidden="true"]').forEach(e => e.remove());
    let i = s, n = !1;
    for (;i < 2 * t || !n; ) {
      const t = e.cloneNode(!0);
      t.setAttribute("aria-hidden", "true"), this.container.appendChild(t), i += s, n = !0;
    }
    this.syncAnimations();
  }
  observeResize() {
    this.resizeObserver = new ResizeObserver(() => {
      this.cloneUntilFull();
    }), this.resizeObserver.observe(this.container);
  }
  syncAnimations() {
    setTimeout(() => {
      this.container.classList.remove("marquee--paused");
    }, 10);
  }
  disconnectedCallback() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }
});